import React from "react";
import AlignSelector from "./AlignSelector";


function VAlignment( { canvas } ) {

const currentElement= canvas.current?.getActiveObject();
  return (
    <AlignSelector
      canvas={canvas}
      object={currentElement}
      property="originY"
      buttonText="VAlignSelector"
    />
  );
}

export default VAlignment;